<mat-card class="fx-margin0-xs">
  <h3 id="cardHeader" *ngIf="showHeading">{{heading}}
    <span class="ml-20pct" *ngIf="subheading1">{{subheading1}}</span>
    <span class="ml-10pct" *ngIf="subheading2">{{subheading2}}</span>
  </h3>

  <mat-card-content>
    <div *ngIf="showInput" class="mb-12px">
      <input type="text" [placeholder]="inputPlaceholder" [(ngModel)]="inputValue" (ngModelChange)="onInputChange($event)"class="w-full h-32px p-6px">  
    </div>

    <div *ngIf="showCheckbox" class="mb-12px">
      <label>
        <input type="checkbox" [(ngModel)]="checkboxValue" (change)="onCheckboxChange(checkboxValue)">
        {{ checkboxLabel }}
      </label>
    </div>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
